import { RouteConfig } from 'react-router-config';

import { dispatchCrossPageEvents } from '@rover/utilities/fireCrossPageEvent';
import { emitCoreWebVitals } from '@rover/utilities/webVitals';

export type UsePerfTrackingEvents = {
  fireCrossPageEvents: () => void;
  fireCWVMetricsEvents: (route: RouteConfig, userIsAuthenticated: boolean) => void;
};

const fireCWVMetricsEvents = async (
  { pageCategory }: RouteConfig,
  userIsAuthenticated: boolean
): Promise<void> => {
  await emitCoreWebVitals(pageCategory, userIsAuthenticated);
};

const fireCrossPageEvents = async (): Promise<void> => {
  await dispatchCrossPageEvents();
};

const usePerfTrackingEvents = (): UsePerfTrackingEvents => {
  return {
    fireCrossPageEvents,
    fireCWVMetricsEvents,
  };
};

export default usePerfTrackingEvents;
